const SDD_ORDER_DETAILS = 'sddOrderDetailsSection';
const STANDARD_SHIPPING_ORDER_DETAILS = 'standardShippingOrderDetailsSection';
const SEE_CURBSIDE_CONCIERGE_LOCATION_LINK = 'curbsideConciergeOrderConfirmationBccContent';

/**
 *
 * @param {Object} pickup - normalized pickup details (`storeDetails` + `content`)
 * @param {boolean} isReadyToPickUp - whether the order header status is "Ready for Pickup"
 * @returns {boolean} true when the curbside instructions block should be shown
 */
const shouldShowCurbsidePickupInstructions = (pickup, isReadyToPickUp) => {
    const storeDetails = pickup?.storeDetails;
    const { isBOPISEnabled, isConciergePurchaseEnabled } = Sephora?.configurationSettings || {};
    const isCurbsideEnabled = !!(isBOPISEnabled && storeDetails?.isBopisable && storeDetails?.isCurbsideEnabled);
    const isConciergeCurbsideEnabled = !!(
        isBOPISEnabled &&
        isConciergePurchaseEnabled &&
        storeDetails?.isBopisable &&
        storeDetails?.isConciergeCurbsideEnabled
    );
    const showCurbsidePickupIndicator = isCurbsideEnabled && !isConciergeCurbsideEnabled;
    const contentfulCurbsideInstruction = pickup?.content?.data?.curbsideInstruction;

    return !!(showCurbsidePickupIndicator && contentfulCurbsideInstruction && isReadyToPickUp);
};

export {
    SDD_ORDER_DETAILS, STANDARD_SHIPPING_ORDER_DETAILS, SEE_CURBSIDE_CONCIERGE_LOCATION_LINK, shouldShowCurbsidePickupInstructions
};
